
import CookieBanner from "./includes/CookieBanner";

window.BCC = window.BCC || {

    get_cookie: function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    },

    set_cookie: function(cname, cvalue, expiry) {
        let date = new Date();
        date.setTime(date.getTime() + expiry);
        let expires = "expires=" + date.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";samesite=lax;path=/";
    },

    delete_cookie: function(cname) {
        window.BCC.set_cookie(cname, null, -1);
    },

    has_cookie: function(cname) {
        return window.BCC.get_cookie(cname) !== '';
    }

};

window.addEventListener('DOMContentLoaded', () => {
    let cookie_banner = new CookieBanner(
      document.getElementById('bcc-wrapper')
    );

    if (!window.BCC.has_cookie('bcc_cookies_accepted')) {
        cookie_banner.open();
    }
});
